// React
import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

// Material UI
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  Grid,
  Typography,
  TextField,
  FormHelperText,
  Radio,
  RadioGroup,
  FormControlLabel,
  Dialog,
  DialogContent
} from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { useConfirm } from 'material-ui-confirm'
import ReactSwitch from 'react-switch'

// Redux
import { useDispatch } from 'react-redux'

// Libs
import PropTypes from 'prop-types'
import { AsyncPaginate } from 'react-select-async-paginate'

// Components
import {
  integrationDisconnectRequest,
  integrationRequest
} from '../../../../../../store/modules/integration/actions'
import Tooltip from '../../../../../../components/Tooltip'

// Valor padrão do endereço do relatório da Iglu (o gerente não precisa mexer).
const DEFAULT_BASE_URL = 'https://relatorios.iglu.com.br'

// Styles
const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(3)
  },
  margin: {
    marginBottom: theme.spacing(1)
  },
  button: {
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 15
  },
  cardAction: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end'
  },
  selectSellerProft: {
    width: '100%'
  },
  helpBox: {
    backgroundColor: '#f9f9fb',
    borderRadius: 8,
    padding: 12,
    marginTop: 12
  },
  sectionsContainer: {
    marginTop: theme.spacing(1)
  },
  switch: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#DCEDC8',
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    padding: '0 8px'
  },
  switchDisabled: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#E2E4E9',
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    padding: '0 8px'
  }
}))

import {
  Container,
  SellersList,
  Seller,
  StatusConteiner,
  SellersFound,
  SellerInfo,
  RadioContent,
  ActualSeller,
  Counters,
  ActiveCounter,
  OtherCounter,
  InactiveCounter,
  EditSellerIcon,
  SelectSeller,
  HeaderDialog,
  SelectForm
} from './styles'
import { normalizeString } from 'utils/normalizeString'
import api from 'repositories/api'

const Iglu = ({ storeIntegrationData, store, loading }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const confirm = useConfirm()

  const provider = 'iglu'

  const { register, handleSubmit, reset, errors } = useForm({
    defaultValues: {
      storeName: '',
      cardUuid: '',
      username: '',
      password: '',
      baseUrl: DEFAULT_BASE_URL
    }
  })

  const [logout, setLogout] = useState(false)
  const [usersList, setUsersList] = useState([])
  const [useOtherSales, setUseOtherSales] = useState(true)

  // Dicionário nome-do-ERP -> vendedor-da-NeoPro
  const [userDict, setUserDict] = useState({})
  const options = usersList.map(user => {
    const { type } = user.stores.find(
      userStore => userStore.storeId === store._id
    )

    return { label: user.name.complete, cpf: user.cpf, type }
  })

  // Dialog
  const [optionValue, setOptionValue] = useState('')
  const [sellerCpf, setSellerCpf] = useState('')
  const [editSellerModal, setEditSellerModal] = useState(false)

  const [actualSeller, setActualSeller] = useState({
    name: '',
    type: ''
  })

  // Contador de vendedores
  const [stateCount, setStateCount] = useState({
    Inactive: 0,
    Other: 0,
    Seller: 0
  })

  // LocalStorage
  const { storeId } = useParams()
  const token = localStorage.getItem('@NeoPro:token')

  // Estilos do Select de vendedores no modal
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isFocused ? '#f9f9fb' : '#000',
      backgroundColor: state.isSelected ? 'green' : 'white',
      backgroundColor: state.isFocused ? '#1E2FA9' : 'white',
      ':active': {
        backgroundColor: state.isSelected && '#1E2FA9'
      },
      fontFamily: 'Roboto',
      fontSize: 14
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1
      const transition = 'opacity 300ms'

      return { ...provided, opacity, transition }
    },
    control: provided => ({
      ...provided,
      fontFamily: 'Roboto',
      fontSize: 14
    })
  }

  // Carrega TODOS os usuários da loja, percorrendo as páginas (o endpoint
  // limita a 100 por página). Feito uma vez no mount; o seletor depois filtra
  // localmente, sem novas chamadas à API.
  const getAllUsers = async () => {
    try {
      const limit = 100
      let page = 1
      let pageCount = 1
      let all = []

      do {
        const response = await api.axios.get(`/user/store/${storeId}`, {
          params: { page, limit },
          headers: { Authorization: `Bearer ${token}` }
        })
        all = all.concat(response.data.items || [])
        pageCount = response.data?.metadata?.pagination?.pageCount || 1
        page += 1
      } while (page <= pageCount)

      setUsersList(all)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (!!storeId && !!token) {
      getAllUsers()
    }
  }, [])

  // Envio do formulário
  const onSubmit = data => {
    storeIntegrationData?.provider === provider && userDict
      ? confirm({
          title: 'Atenção',
          description:
            'Você confirma a associação dos vendedores do relatório da Iglu com os vendedores da NeoPro? Quem ficar como "Vendas da loja" terá as vendas somadas em Outras vendas.',
          confirmationText: 'Sim',
          cancellationText: 'Cancelar'
        })
          .then(() => {
            dispatch(
              integrationRequest(
                {
                  ...store.integration,
                  userDict,
                  useOtherSales,
                  provider
                },
                provider,
                storeId,
                token
              )
            )
          })
          .catch(() => {})
      : dispatch(
          integrationRequest(
            { baseUrl: DEFAULT_BASE_URL, ...data, useOtherSales, provider },
            provider,
            storeId,
            token
          )
        )
  }

  // Desconectar integração
  const handleDisconnectIntegration = () => {
    confirm({
      title: 'Atenção',
      description:
        'Você tem certeza que deseja remover a integração com a Iglu?',
      confirmationText: 'Sim',
      cancellationText: 'Cancelar'
    })
      .then(() => {
        setLogout(true)
        dispatch(integrationDisconnectRequest(provider, storeId, token))
      })
      .catch(() => {})
  }

  useEffect(() => {
    if (
      storeIntegrationData?.storeName &&
      storeIntegrationData?.provider === provider
    )
      reset({
        storeName: storeIntegrationData.storeName,
        cardUuid: storeIntegrationData.cardUuid,
        baseUrl: storeIntegrationData.baseUrl || DEFAULT_BASE_URL
      })
    if (storeIntegrationData?.provider === provider)
      setUseOtherSales(storeIntegrationData?.useOtherSales ?? true)
  }, [storeIntegrationData])

  const renderError = error =>
    errors[error] && (
      <FormHelperText id='component-error-text'>
        Este campo é obrigatório
      </FormHelperText>
    )

  // Carrega o dicionário (userDict)
  useEffect(() => {
    if (storeIntegrationData?.userDict) {
      setUserDict(storeIntegrationData?.userDict)
      setStateCount(
        Object.values(storeIntegrationData?.userDict).reduce(
          (acc, value) => {
            acc[String(value)] >= 0 ? acc[String(value)]++ : acc.Seller++
            return acc
          },
          {
            Inactive: 0,
            Other: 0,
            Seller: 0
          }
        )
      )
    }
  }, [])

  const handleSeller = (name, type) => {
    if (
      userDict[name] !== type ||
      userDict[name] !== sellerCpf ||
      userDict[name] !== type.cpf
    ) {
      const oldType = String(userDict[name])
      const newType = String(sellerCpf || type.cpf || type)

      stateCount[oldType] >= 0 ? stateCount[oldType]-- : stateCount.Seller--
      stateCount[newType] >= 0 ? stateCount[newType]++ : stateCount.Seller++

      setStateCount(stateCount)
    }
    setUserDict({ ...userDict, [name]: sellerCpf || type.cpf || type })
    setEditSellerModal(false)
  }

  // LoadOptions para o Select de vendedores (Modal). Filtra localmente a lista
  // já carregada — sem novas chamadas à API.
  const loadOptions = (search, prevOptions) => {
    const filteredOptions = options.filter(
      ({ label, type }) =>
        type === 'seller' &&
        (!search || label.toLowerCase().includes(search.toLowerCase()))
    )

    return {
      options: filteredOptions.slice(prevOptions.length),
      hasMore: false
    }
  }

  return (
    <Card>
      <form autoComplete='off' noValidate onSubmit={handleSubmit(onSubmit)}>
        <CardHeader title='Iglu' />
        <Divider />
        <CardContent>
          <Typography>
            Esta integração puxa as vendas direto do relatório da Iglu (Metabase)
            e lança automaticamente na NeoPro.
          </Typography>

          {storeIntegrationData?.provider !== provider ? (
            <>
              <div className={classes.helpBox}>
                <Typography variant='subtitle2' style={{ fontWeight: 700 }}>
                  Como preencher (passo a passo)
                </Typography>
                <Typography variant='body2' style={{ marginTop: 6 }}>
                  <b>1. Nome da loja:</b> abra o relatório da Iglu no navegador.
                  No filtro <b>“Lojas”</b>, selecione a sua loja e copie o nome
                  exatamente como aparece lá (com acentos e maiúsculas).
                </Typography>
                <Typography variant='body2' style={{ marginTop: 6 }}>
                  <b>2. Código do relatório:</b> ainda no navegador, olhe o
                  endereço (a barra de cima). Copie a sequência de letras e
                  números que vem logo depois de <b>/question/</b>. O formato é:{' '}
                  <b>xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx</b>.
                </Typography>
                <Typography variant='body2' style={{ marginTop: 6 }}>
                  <b>3.</b> Cole os dois nos campos abaixo e clique em{' '}
                  <b>Salvar</b>. Pronto: as vendas começam a ser importadas.
                </Typography>
                <Typography
                  variant='body2'
                  style={{ marginTop: 6, color: '#5B5B76' }}
                >
                  Observação: o relatório da Iglu identifica o vendedor pelo{' '}
                  <b>nome</b> (não pelo CPF). Depois de salvar, vai aparecer a
                  lista de vendedores encontrados para você confirmar quem é quem
                  na NeoPro.
                </Typography>
              </div>
              <Divider style={{ marginTop: '1rem' }} />
              <Grid container spacing={1}>
                <Grid item sm={6} xs={12}>
                  <TextField
                    label='Nome da loja no relatório'
                    placeholder='Nome da loja como aparece no relatório'
                    fullWidth
                    variant='outlined'
                    margin='normal'
                    id='storeName'
                    name='storeName'
                    className={classes.textField}
                    onFocus={event => event.target.select()}
                    inputRef={register({ required: true })}
                    error={!!errors.storeName}
                  />
                  {renderError('storeName')}
                </Grid>
                <Grid item sm={6} xs={12}>
                  <TextField
                    label='Código do relatório'
                    placeholder='xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'
                    fullWidth
                    variant='outlined'
                    margin='normal'
                    id='cardUuid'
                    name='cardUuid'
                    className={classes.textField}
                    onFocus={event => event.target.select()}
                    inputRef={register({ required: true })}
                    error={!!errors.cardUuid}
                  />
                  {renderError('cardUuid')}
                </Grid>
                <Grid item sm={6} xs={12}>
                  <TextField
                    label='Usuário do relatório'
                    placeholder='Usuário de acesso ao relatório da Iglu'
                    fullWidth
                    variant='outlined'
                    margin='normal'
                    id='username'
                    name='username'
                    className={classes.textField}
                    onFocus={event => event.target.select()}
                    inputRef={register({ required: true })}
                    error={!!errors.username}
                  />
                  {renderError('username')}
                </Grid>
                <Grid item sm={6} xs={12}>
                  <TextField
                    label='Senha do relatório'
                    placeholder='Senha de acesso ao relatório da Iglu'
                    type='password'
                    fullWidth
                    variant='outlined'
                    margin='normal'
                    id='password'
                    name='password'
                    className={classes.textField}
                    onFocus={event => event.target.select()}
                    inputRef={register({ required: true })}
                    error={!!errors.password}
                  />
                  {renderError('password')}
                </Grid>
              </Grid>
              <Divider style={{ marginTop: '1rem' }} />
              <Grid
                container
                alignItems='center'
                className={classes.sectionsContainer}
              >
                <Grid item>
                  <div
                    className={
                      useOtherSales ? classes.switch : classes.switchDisabled
                    }
                  >
                    <ReactSwitch
                      onColor='#09177d'
                      height={15}
                      width={40}
                      onHandleColor='#364AD3'
                      offHandleColor='#364AD3'
                      checkedIcon={false}
                      uncheckedIcon={false}
                      handleDiameter={20}
                      checked={useOtherSales}
                      onChange={() => setUseOtherSales(!useOtherSales)}
                    />
                  </div>
                </Grid>
                <Grid item xs={10}>
                  <CardHeader
                    title='Outras vendas'
                    subheader='Agrupe em "Outras vendas" as vendas de quem não for vinculado a um vendedor da NeoPro.'
                    titleTypographyProps={{ variant: 'h6' }}
                  />
                </Grid>
              </Grid>
            </>
          ) : (
            <Container>
              <SellersFound>
                <Typography variant='h6'>Vendedores encontrados </Typography>
                {storeIntegrationData?.userDict && (
                  <Counters>
                    <InactiveCounter>{stateCount.Inactive}</InactiveCounter>
                    <OtherCounter>{stateCount.Other}</OtherCounter>
                    <ActiveCounter>{stateCount.Seller}</ActiveCounter>
                  </Counters>
                )}
              </SellersFound>
              <SellersList>
                {storeIntegrationData?.userDict ? (
                  Object.entries(userDict)
                    .sort((a, b) =>
                      a[0].toLowerCase().localeCompare(b[0].toLowerCase())
                    )
                    .map(([seller, type], index) => (
                      <Seller
                        key={index}
                        onClick={() => {
                          setEditSellerModal(true)
                          setActualSeller({ name: seller, type: type })
                          setOptionValue(type)
                        }}
                      >
                        <SellerInfo>
                          <Typography
                            variant='subtitle2'
                            style={{ fontWeight: 700 }}
                          >
                            {seller}
                          </Typography>
                          <StatusConteiner>
                            <Typography
                              variant='body2'
                              style={{ fontWeight: 700 }}
                            >
                              NeoPro:
                            </Typography>
                            <Typography
                              variant='body2'
                              style={{
                                color:
                                  type === 'Inactive'
                                    ? '#e74c3c'
                                    : type === 'Other'
                                    ? '#f39c12'
                                    : '#2ecc71',
                                fontWeight: 700
                              }}
                            >
                              {{
                                Inactive: 'Inativo',
                                Other: 'Vendas da loja'
                              }[type] || [
                                options.find(option => option.cpf === type)
                                  ?.label || type
                              ]}
                            </Typography>
                          </StatusConteiner>
                        </SellerInfo>
                        <EditSellerIcon />
                      </Seller>
                    ))
                ) : (
                  <div
                    style={{
                      padding: '20px',
                      width: '100%',
                      textAlign: 'center'
                    }}
                  >
                    <Typography variant='subtitle2'>
                      Não encontramos vendedores cadastrados.
                    </Typography>
                  </div>
                )}
              </SellersList>
            </Container>
          )}
        </CardContent>
        <CardActions>
          <Button
            color='primary'
            variant='contained'
            disabled={loading}
            className={classes.button}
            type='submit'
          >
            {loading ? (
              <>
                <CircularProgress
                  size={24}
                  style={{ color: '#fff', marginRight: '8px' }}
                />
                {storeIntegrationData?.provider === provider
                  ? 'Atualizando...'
                  : 'Conectando à Iglu...'}
              </>
            ) : storeIntegrationData?.provider === provider ? (
              'Atualizar'
            ) : (
              'Salvar'
            )}
          </Button>
          {storeIntegrationData?.provider === provider && (
            <Button
              style={{ color: '#e74c3c' }}
              className={classes.button}
              disabled={loading && logout}
              onClick={() => handleDisconnectIntegration()}
            >
              {loading && logout ? (
                <>
                  <CircularProgress
                    size={24}
                    style={{ color: '#e74c3c', marginRight: '8px' }}
                  />{' '}
                  {' Desconectando...'}
                </>
              ) : (
                'Desconectar'
              )}
            </Button>
          )}
        </CardActions>
      </form>

      {/* Modal de edição do vendedor */}
      <Dialog
        open={editSellerModal}
        fullWidth
        onClose={() => {
          setEditSellerModal(false)
          setOptionValue('')
          setSellerCpf('')
          setActualSeller({ name: '', type: '' })
        }}
        maxWidth='xs'
      >
        <DialogContent className={classes.dialogContent}>
          <HeaderDialog>
            <Typography variant='h4'>Vincular vendedor</Typography>
            <ActualSeller>{actualSeller.name}</ActualSeller>
            <Typography variant='subtitle2'>
              Selecione como deseja vincular o vendedor:
            </Typography>
          </HeaderDialog>
          <RadioGroup
            defaultValue={
              actualSeller.type !== 'Inactive' && actualSeller.type !== 'Other'
                ? 'Seller'
                : actualSeller.type
            }
            name='radio-buttons-group'
          >
            <SelectSeller>
              <FormControlLabel
                data-for='tooltip-sales-others'
                data-tip='Habilite “Agrupar outras vendas” nas configurações de integração do ERP'
                value='Seller'
                control={<Radio size='small' />}
                label={<RadioContent />}
                onChange={e => setOptionValue(e.target.value)}
                disabled={!storeIntegrationData?.useOtherSales}
                style={{ marginRight: 0 }}
              />
              <SelectForm>
                <AsyncPaginate
                  defaultValue={options.find(
                    option => option.cpf === actualSeller.type
                  )}
                  loadOptions={loadOptions}
                  placeholder='Selecione um vendedor'
                  noOptionsMessage={() => 'Nenhum vendedor encontrado'}
                  loadingMessage={() => 'Carregando...'}
                  className={classes.selectSellerProft}
                  maxMenuHeight='140px'
                  styles={customStyles}
                  theme={theme => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: 'hotpink',
                      primary: '#1E2FA9'
                    }
                  })}
                  onChange={value => {
                    setSellerCpf(value.cpf)
                    setOptionValue(value.type)
                  }}
                  isDisabled={
                    normalizeString(optionValue) === 'inactive' ||
                    normalizeString(optionValue) === 'other' ||
                    !actualSeller.type
                  }
                />
                <Typography variant='subtitle2' style={{ paddingLeft: 5 }}>
                  Vincule o usuário do vendedor na NeoPro com as vendas do
                  relatório da Iglu.
                </Typography>
              </SelectForm>
            </SelectSeller>
            {!storeIntegrationData?.useOtherSales && (
              <Tooltip id='tooltip-sales-others' place='left' />
            )}
            <Divider />
            <FormControlLabel
              data-for='tooltip-sales-others'
              data-tip='Habilite “Agrupar outras vendas” nas configurações de integração do ERP'
              value='Other'
              control={<Radio size='small' />}
              label={
                <RadioContent>
                  <Typography variant='h6'>Outras vendas</Typography>
                  <Typography variant='subtitle2'>
                    Agrupe as vendas desse vendedor do relatório em Outras vendas
                    na NeoPro.
                  </Typography>
                </RadioContent>
              }
              onChange={e => setOptionValue(e.target.value)}
              disabled={!storeIntegrationData?.useOtherSales}
            />
            <Divider />
            <FormControlLabel
              value='Inactive'
              control={<Radio size='small' />}
              label={
                <RadioContent>
                  <Typography variant='h6'>Inativo</Typography>
                  <Typography variant='subtitle2'>
                    Desconsidere as vendas desse vendedor do relatório.
                  </Typography>
                </RadioContent>
              }
              onChange={e => setOptionValue(e.target.value)}
            />
          </RadioGroup>
        </DialogContent>
        <CardActions className={classes.cardAction}>
          <Typography
            variant='subtitle2'
            style={{ cursor: 'pointer' }}
            onClick={() => setEditSellerModal(false)}
          >
            Cancelar
          </Typography>
          <Button
            color='primary'
            variant='contained'
            className={classes.button}
            type='submit'
            onClick={() => {
              actualSeller && optionValue
                ? handleSeller(
                    actualSeller.name,
                    Object.values(
                      store.users.map(seller => seller.name.complete)
                    )[optionValue] || optionValue
                  )
                : toast.error('Confirme a escolha do vendedor')
              setOptionValue('')
              setSellerCpf('')
            }}
          >
            Salvar
          </Button>
        </CardActions>
      </Dialog>
    </Card>
  )
}

Iglu.propTypes = {
  store: PropTypes.object,
  storeIntegrationData: PropTypes.object,
  loading: PropTypes.bool
}

export default Iglu
